(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/themeDefault"] = factory();
	else
		root["@makolab/library-react/dist/themeDefault"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 364);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/utils");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("process/browser.js");

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "baseThemeConfig", function() { return baseThemeConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_blue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_blue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_blue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_pink__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_pink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_pink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_colors_red__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_colors_red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_colors_red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animations_jss__ = __webpack_require__(82);
var PUBLIC_URL=process.env.PUBLIC_URL||'';// https://material-ui.com/customization/themes/
// https://cimdalli.github.io/mui-theme-generator/
var baseThemeConfig={themeName:'Default',breakpoints:{values:{xs:0,sm:576,md:768,lg:992,xl:1200}},palette:{type:'light',primary:__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_blue___default.a,secondary:__WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_pink___default.a,error:__WEBPACK_IMPORTED_MODULE_3__material_ui_core_colors_red___default.a},transitions:{duration:{complex:500}},overrides:{},props:{MuiWithWidth:{initialWidth:'lg'// useful for server side rendering
}},typography:{useNextVariants:true},mlbCustomVariables:{// put your custom project theme variables here
animationIds:Object.assign({},__WEBPACK_IMPORTED_MODULE_4__animations_jss__["ANIMATION_IDS"]),animationDefs:Object.assign({},__WEBPACK_IMPORTED_MODULE_4__animations_jss__["ANIMATION_DEFINITIONS"]),svgIconUrl:PUBLIC_URL+'/static/svg/icon-map.svg'}};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__["createMuiTheme"])(baseThemeConfig));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(23)))

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/colors/blue");

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/colors/pink");

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/colors/red");

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANIMATION_IDS", function() { return ANIMATION_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANIMATION_DEFINITIONS", function() { return ANIMATION_DEFINITIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__commons_utils__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// used for css @keyframes declarations, accessible via theme
var ANIMATION_IDS={ANIMATION_SPIN:'animation-spin-'+Object(__WEBPACK_IMPORTED_MODULE_0__commons_utils__["randomId"])()};// used by global.jss.js css declaration, accessible via theme
var ANIMATION_DEFINITIONS=_defineProperty({},'@keyframes '+ANIMATION_IDS.ANIMATION_SPIN,{from:{transform:'rotate(0deg)'},to:{transform:'rotate(360deg)'}});

/***/ })

/******/ });
});
//# sourceMappingURL=themeDefault.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/themeDefault.js
// module id = 916
// module chunks = 0